export default "__VITE_ASSET___jHdkBZB__"